import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as CryptoJS from 'crypto-js';

import { DashboardService } from '../../../services/dashboard.service';

import { Constants } from '../../../../../app.const';
import { WorkConstants } from "../../../../work/work.const";

declare var $: any;
@Component({
  selector: 'app-code-standard',
  templateUrl: './code-standard.component.html',
  styleUrls: ['./code-standard.component.css'],
  providers: [DashboardService]
})
export class CodeStandardComponent implements OnInit {

  folderId: string;
  authUser: any = {};
  folderFileType: string;
  codeStandardlList: Array<any> = [];
  private constants = Constants;

  constructor(
    private DashboardService: DashboardService,
  ) { }

  ngOnInit() {
    let $this = this;
    // get cv folder ID
    this.folderId = this.constants.driverCoderStandardFolderId;
    //get folder file type in google
    this.folderFileType = this.constants.folderMinTypeInGoogle;
    this.getGoogleFileList(this.folderId);

  }

  /**
   * kaushalya
   * 2017-07-21
   * get google drive folder content
   */
  getGoogleFileList(folderId) {
    this.DashboardService.getAvailableCvs({ folderId }).subscribe(
      res => {
        this.codeStandardlList = Object.keys(res.data.fileList).map((key) => { return res.data.fileList[key] });
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/maindashboard/code-standard/code-standard.component.ts